module.exports = __webpack_public_path__ + "static/media/d16kz.d2e97a56.pdf";